import { Box, Button, Typography, TextField } from "@mui/material";
import keyicon from "../../assets/svg/SideBar/keyicon.svg";
import home from "../../assets/svg/SideBar/layout.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { Email } from "@mui/icons-material";
import { Sentemail } from "../../store/keygenreration/action";
import { useState } from "react";

const Key = () => {
  const location = useLocation();
  const reduxData = useSelector((state) => state?.keygenreration?.data);
  const locationData = location?.state?.payload;
  const licenseData = locationData || reduxData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(licenseData?.LicenseKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleBackHome = () => {
    navigate("/generatekeys");
  };

  const handleSent = () => {
    const payload = {
      LicenseKey: licenseData?.LicenseKey,
      EnterpriseID: licenseData?.EnterpriseID || licenseData?.ClientID,
    };
    // console.log(licenseData)
    dispatch(Sentemail(payload));
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="81vh"
      bgcolor="#fff"
      padding={3}
      style={{ margin: "30px", borderRadius: "8px" }}
    >
      <img src={keyicon} alt="key-icon" />

      <Typography variant="h6" mt={2} mb={1} align="center">
        Key Generated Successfully
      </Typography>

      <Typography
        variant="body1"
        align="center"
        maxWidth="40%"
        style={{ color: "#64748B" }}
      >
        Corem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate
        libero et velit interdum, ac aliquet odio mattis.
      </Typography>

      <Box
        display="flex"
        alignItems="center"
        sx={{
          width: { xs: "100%", sm: "auto", lg: "495px" },
          height: "56px",
          gap: "16px",
          mt: 2,
          mb: 3,
          bgcolor: "#fff",
          padding: { xs: "8px", sm: "12px", md: "16px 14px" },
        }}
      >
        <TextField
          defaultValue={licenseData?.LicenseKey || ""}
          variant="outlined"
          fullWidth
          InputProps={{
            readOnly: true,
            style: {
              border: "none",
              color: "#64748B",
              borderColor: "#E2E8F0",
              borderRadius: "8px",
            },
          }}
        />
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        gap={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          onClick={handleCopy}
          sx={{
            backgroundColor: "#3B82F6",
            height: "48px",
            textTransform: "none",
            display: "flex",
            alignItems: "center",
            width: { xs: "100%", sm: "auto" },
            justifyContent: "center",
          }}
        >
          Copy to Clipboard
          <span
            style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}
          >
            <ContentPasteIcon />
          </span>
        </Button>

        <Button
          variant="outlined"
          color="primary"
          onClick={handleBackHome}
          sx={{
            borderColor: "#E2E8F0",
            color: "#000",
            textTransform: "none",
            height: "48px",
            display: "flex",
            alignItems: "center",
            width: { xs: "100%", sm: "auto" },
            justifyContent: "center",
          }}
        >
          Back Home
          <span
            style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}
          >
            <img src={home} alt="home-icon" />
          </span>
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSent}
          sx={{
            borderColor: "#E2E8F0",
            color: "#fff",
            textTransform: "none",
            height: "48px",
            display: "flex",
            alignItems: "center",
            width: { xs: "100%", sm: "auto" },
            justifyContent: "center",
          }}
        >
          Send
          <span
            style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}
          >
            <Email sx={{ color: "#fff" }} />
          </span>
        </Button>
      </Box>

      {copied && (
        <Typography mt={2} variant="body2" color="green">
          Copied to clipboard!
        </Typography>
      )}
    </Box>
  );
};

export default Key;
